import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from './AppIcon';

const NavigationBreadcrumbs = () => {
  const location = useLocation();

  const breadcrumbMap = {
    '/admin-orders-management': [
      { label: '관리자', path: '/admin-orders-management' },
      { label: '주문 관리', path: '/admin-orders-management' },
    ],
    '/admin-before-after-management': [
      { label: '관리자', path: '/admin-orders-management' },
      { label: '비포&애프터', path: '/admin-before-after-management' },
    ],
    '/admin-products-management': [
      { label: '관리자', path: '/admin-orders-management' },
      { label: '상품 관리', path: '/admin-products-management' },
    ],
    '/admin-customer-management': [
      { label: '관리자', path: '/admin-orders-management' },
      { label: '고객 관리', path: '/admin-customer-management' },
    ],
    '/admin-terms-management': [
      { label: '관리자', path: '/admin-orders-management' },
      { label: '약관 관리', path: '/admin-terms-management' },
    ],
  };

  const breadcrumbs = breadcrumbMap?.[location?.pathname] || [];

  if (breadcrumbs?.length === 0) {
    return null;
  }

  return (
    <nav className="bg-card px-4 py-3 shadow-card sm:px-6 lg:px-8" aria-label="Breadcrumb">
      <div className="mx-auto max-w-7xl">
        <ol className="flex items-center space-x-2 text-sm">
          {breadcrumbs?.map((crumb, index) => (
            <li key={`${crumb?.path}-${index}`} className="flex items-center">
              {index > 0 && (
                <Icon name="ChevronRight" size={16} className="mx-2 text-muted-foreground" />
              )}
              {index === breadcrumbs?.length - 1 ? (
                <span className="font-medium text-foreground">{crumb?.label}</span>
              ) : (
                <Link
                  to={crumb?.path}
                  className="text-muted-foreground transition-colors duration-150 ease-out hover:text-foreground"
                >
                  {crumb?.label}
                </Link>
              )}
            </li>
          ))}
        </ol>
      </div>
    </nav>
  );
};

export default NavigationBreadcrumbs;